import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&utm_source=FB&country=US&area=female&exp=web_data_input_screens_optimized~1
			funnel: {
				id: 'ob-female-funnel-data-inputs',
				locale: ['en'],
			},
		},
	},
]

export default config
